import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import InventoryCategoryForm from "../../../Components/Forms/Pages/AssetManagement/InventoryCategory/InventoryCategoryForm";
import DrawerContext from "../../../Context/DrawerContext";
import {
  addInventoryCategory,
  getInventoryCategories,
} from '../../../Services/AssetManagement/InventoryCategoryService';
import LinearProgress from '@mui/material/LinearProgress';
import SnackbarContext from "../../../Context/SnackbarContext";


const formRules = {
    'name': {required: true}
}

const AddInventoryCategory = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm();
    const {data, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [inventoryCategories, setInventoryCategories] = useState(0);

    useEffect(() => {
        setDrawerTitle(strings.pages.assetManagement.inventoryCategory.addInventoryCategory.pageTitle);
    });

    useEffect(() => {
        fetchInventoryCategories(); 
    },[])

    const fetchInventoryCategories = (term = "") => {
        getInventoryCategories({term}).then((response) => {
          if (!response || !response.ok) {
            return;
          }
          setInventoryCategories(response.data.result);
        });
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        addInventoryCategory(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <InventoryCategoryForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                inventoryCategories = {inventoryCategories}
                errors={errors} data={data} form={form}
                onParentChangeFilter={fetchInventoryCategories}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default AddInventoryCategory;